/**
 * A gate for autosaved edits. A field that saves on a debounce writes many
 * times while one person edits it once; the gate passes the first write of
 * an editing session and holds the rest. A write within `windowMs` of the
 * previous write on the same key belongs to the same session, so a session
 * ends only after that long without a write.
 *
 * The key names what was edited (an entity and its fields), never a value.
 */
export function createEditSessionGate(windowMs: number): (key: string) => boolean {
  const lastWrite = new Map<string, number>();
  return (key) => {
    const now = Date.now();
    const last = lastWrite.get(key);
    lastWrite.set(key, now);
    return last === undefined || now - last > windowMs;
  };
}
